<template>
  <div class="uikit layout">
    <div class="layout__title">UIKit</div>

    <div class="uikit__tabs">
      <c-tabs :items="tabs" with-routing />
    </div>

    <div class="uikit__content">
      <router-view />
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/tabs";

export default {
  name: "uikitnew",

  components: {
    "c-tabs": Tabs,
  },

  data() {
    return {
      activeTab: "selects",

      tabs: [
        { label: "Кнопки", value: "uikit-buttons" },
        { label: "Элементы формы", value: "uikit-form" },
        { label: "Диаграммы", value: "uikit-charts" },
        { label: "Модальные окна", value: "uikit-modals" },
        { label: "Прочее", value: "uikit-other" },
      ],
    };
  },

  mounted() {
    // if (this.$route.path === '/uikitnew') {
    //   this.$router.push({ path: '/uikitnew/selects' })
    // }
  },

  methods: {
    // changeTab (value) {
    //   this.activeTab = value;
    //   this.$router.push({ path: '/uikitnew/selects' })
    // }
  },
};
</script>

<style scoped lang="scss">
.uikit {
  &__tabs {
    margin-top: 30px;
  }

  &__content {
    margin-top: 30px;
  }
}

::v-deep .ps__rail-x {
  z-index: 351;
  background: #ffffff !important;
}

::v-deep .ps__rail-x:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-30px, 0);
  box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
  z-index: -1;
  height: 24px;
  width: calc(100vw - 60px);
  background: #ffffff;
}

::v-deep .ps__rail-x:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, calc(-50% + 1px));
  border-radius: 10px;
  z-index: -1;
  height: 4px;
  width: calc(100% - 34px);
  background: #dfe4ef;
}
</style>
